export const CyrelaIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="32" height="32" rx="16" fill="white" />
    <g clipPath="url(#clip0_642_1738)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.3299 22.7546C20.3299 22.9963 20.1394 23.1937 19.9064 23.1937H12.1669C11.9338 23.1937 11.7429 22.9963 11.7429 22.7546V14.7299C11.7429 14.489 11.9338 14.2913 12.1669 14.2913H19.9064C20.1394 14.2913 20.3299 14.489 20.3299 14.7299V22.7546ZM9 26V11.4844H23V26H9ZM15.968 6.00015C15.9187 6.02732 22.9031 9.86594 22.9031 9.86594H9.09693C9.09693 9.86594 16.0175 5.9719 15.968 6.00015Z"
        fill="#E11E1D"
      />
    </g>
    <defs>
      <clipPath id="clip0_642_1738">
        <rect width="14" height="20" fill="white" transform="translate(9 6)" />
      </clipPath>
    </defs>
  </svg>
);
